<app-layout-modulo-gerencial
  [logo]="sessao.logoEmpresa"
  [iniciais]="sessao.iniciaisEmpresa"
  [nome]="sessao.nomeEmpresa"
  [agora]="agora"
  aba="menu"
  [itens]="itensMenu"
  (selecionar)="sessao.abrir($event)"
  (sair)="sessao.sair()">
  <app-painel-dashboard-gerencial
    [identificacao]="sessao.identificacao"
    [atalhos]="atalhos"
    (selecionar)="sessao.abrir($event)">
  </app-painel-dashboard-gerencial>
</app-layout-modulo-gerencial>
